import React, { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Flowers.css";
import LazyImage from "./LazyImage";

const FlowerSection = ({
  flowers,
  title,
  subtitle = null,
  storageKey = "FLOWER_SCROLL_POSITION",
  id = null,
}) => {
  const navigate = useNavigate();

  // Save scroll position
  const saveScrollPosition = useCallback(() => {
    const data = {
      position: window.scrollY,
      timestamp: Date.now(),
    };
    sessionStorage.setItem(storageKey, JSON.stringify(data));
  }, [storageKey]);

  // Get scroll position
  const getScrollPosition = useCallback(() => {
    const data = sessionStorage.getItem(storageKey);
    if (!data) return null;

    try {
      return JSON.parse(data);
    } catch (e) {
      return null;
    }
  }, [storageKey]);

  // Restore scroll position on return via back button
  useEffect(() => {
    const scrollData = getScrollPosition();

    if (scrollData) {
      const timeSinceLastVisit = Date.now() - scrollData.timestamp;

      // If we revisit within a short time (5 seconds), it's likely via back button
      if (timeSinceLastVisit < 5000) {
        setTimeout(() => {
          window.scrollTo(0, scrollData.position);
        }, 200);
      } else {
        // If it's been longer, user likely navigated directly to this page
        // For homepage sections, we don't want to scroll to top
      }
    }
  }, [getScrollPosition]);

  // Navigate to flower detail page
  const handleFlowerClick = useCallback(
    (flowerId) => {
      saveScrollPosition();
      navigate(`/flower/${flowerId}`);
    },
    [navigate, saveScrollPosition]
  );

  return (
    <div className="section flower-section" id={id}>
      <h1 className="heading-secondary">{title}</h1>

      {subtitle && <p className="subheading">{subtitle}</p>}

      <div className="flower-grid">
        {flowers.map((flower) => (
          <div
            key={flower.id}
            className="flower-card"
            onClick={() => handleFlowerClick(flower.id)}
          >
            <LazyImage src={flower.images[0]} alt={flower.name} />
            <h3 className="flowerName">{flower.name}</h3>
            <p className="flowerPrice">{flower.price}</p>
            <button
              className="btn buyNow"
              onClick={(e) => {
                e.stopPropagation();
                handleFlowerClick(flower.id);
              }}
            >
              Comanda acum
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlowerSection;
